export class utils{
	public url:string;
	constructor(){
		//this.url = "http://192.168.100.31/EPSEP_BACK/";
		//this.url = "http://13.85.28.87/SAE_BACK/"; // ESSTA ES LA BUENA
		this.url = "https://mrsae.mx/SAE_BACK/"; // ESSTA ES LA BUENA NUEVA
		//this.url = "http://13.85.28.87/EPSEP_BACK/"; 
		//this.url = "http://localhost:54898/";
		
		
		//this.url = "http://localhost:54898/";
		//this.url = "http://localhost/EPSEP_BACK/";
	}

	toast(mensaje, snackBar){
		snackBar.open(mensaje, "cerrar", {
        	duration: 2500,
      	});
	}

	changeFormatDate(inputFormat:any, formato:string) {
	    function pad(s) { return (s < 10) ? '0' + s : s; }
	    var d = new Date(inputFormat);
	    switch (formato) {
        case "dd-mm-yyyy":
           return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('-');
        case "yyyy-mm-dd":
           return [d.getFullYear(), pad(d.getMonth()+1),pad(d.getDate())].join('-');
      }
	}

	convertDate(inputFormat:any, formato:string) {
	    function pad(s) { return (s < 10) ? '0' + s : s; }
	    var d = inputFormat;
      switch (formato) {
        case "dd-mm-yyyy":
           return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('-');
        case "yyyy-mm-dd":
           return [d.getFullYear(), pad(d.getMonth()+1),pad(d.getDate())].join('-');
      }
	   
	}
}


// WEBPACK FOOTER //
// ./src/app/utils/utils.ts